import { render, staticRenderFns } from "./EditorNumberAge.vue?vue&type=template&id=f029c37a&scoped=true&"
import script from "./EditorNumberAge.vue?vue&type=script&lang=js&"
export * from "./EditorNumberAge.vue?vue&type=script&lang=js&"
import style0 from "./EditorNumberAge.vue?vue&type=style&index=0&id=f029c37a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f029c37a",
  null
  
)

export default component.exports